import axiosClient from "../api/axiosClient";

export const getFaq = async (groupId?: number) => {
  const result = await axiosClient.get(`2/faq-setting?group_id=${groupId}`);
  return result.data;
};
